// import React, { useEffect, useState } from "react";
// import { Tables } from "../../../../components/Elements/Tables/Tables";
// import { ReactComponent as BackIcon } from "../../../../assets/svgs/back-square.svg";
// import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
// import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { Button } from "antd";
// import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// import SortData from "../../../../components/Elements/SortData.js/SortData";
// import { useLocation, useNavigate } from "react-router-dom";
// import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
// import AddQuestion from "./AddNew/AddQuestion";
// import { getApi } from "../../../../api/api_instance";
// import { API_URLS } from "../../../../api/apiUrls";
// import EditQuestion from "./EditQuestion";
// import { IoArrowBackCircleOutline } from "react-icons/io5";
// const Questions = () => {
//   const [OpenAddNew, setOpenAddnew] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const sectionId = location.state?.sectionId || "";
//   const subSectionId = location.state?.subSectionId || "";
//   const [questionData, setQuestionData] = useState([]);
//   const [tableData, setTableData] = useState([]);
//   const [page, setPage] = useState(1);
//   const [serach, setSearch] = useState("");
//   const [editModalOpen, setEditModalOpen] = useState(false);
//   const [selectedQuestion, setSelectedQuestion] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");

//   const headers = [
//     { label: "Sr. No.", key: "serial" },
//     { label: "Questions", key: "questions" },
//     { label: "Type", key: "type" },
//     // { label: "Emmmision Factor", key: "emmisionFactor" },
//     { label: "Created Date & Time", key: "createdDateAndTime" },
//     { label: "Status", key: "status" },
//     { label: "Action", key: "action" },
//   ];

//  const handleSearch = (value) => {
//     setSearchTerm(value); // triggers debounce automatically
//   };

//   const handleOpenAddNew = () => {
//     setOpenAddnew(true);
//   };
//   const handleOpenEditNew = () => {
//     setEditModalOpen(true);
//   };

//   const handleAddQuestionSuccess = (newQuestion) => {
//     console.log("New Question Data:", newQuestion);

//     setQuestionData((prevData) => [...prevData, newQuestion]);

//     setTableData((prevTableData) => [
//       ...prevTableData,
//       {
//         key: newQuestion._id,
//         serial: prevTableData.length + 1,
//         questions: newQuestion.label,
//         type: newQuestion.type,
//         emmisionFactor: "-",
//         createdDateAndTime: "-",
//         status: "-",
//         action: (
//           <div className="flex gap-4 items-center">
//             <EyeIcon
//               className=""
//               style={{ fontSize: "18px", cursor: "pointer" }}
//               onClick={() => {}}
//             />
//             <EditIcon
//               style={{ cursor: "pointer" }}
//               onClick={handleOpenEditNew}
//             />

//             <CustomSwitch
//               checked={true} // Default state
//               onChange={(checked) =>
//                 console.log(`Custom switch toggled, Status: ${checked}`)
//               }
//             />
//           </div>
//         ),
//       },
//     ]);
//   };

//   const convertTableData = (question, serial) => {
//     return {
//       key: question._id,
//       serial,
//       questions: question.label,
//       type: question.type,
//       emmisionFactor: "-",
//       createdDateAndTime: "-",
//       status: "-",
//       action: (
//         <div className="flex gap-4 items-center">
//           <EyeIcon
//             className=""
//             style={{ fontSize: "18px", cursor: "pointer" }}
//             onClick={() => {}}
//           />
//           <EditIcon style={{ cursor: "pointer" }} />
//           <CustomSwitch
//             checked={true} // Default state
//             onChange={(checked) =>
//               console.log(`Custom switch toggled, Status: ${checked}`)
//             }
//           />
//         </div>
//       ),
//     };
//   };

//   const handleBack = () => {
//     navigate("/organization/my-question-bank/sub-section", {
//       state: { sectionId: sectionId },
//     });
//   };

//   const getQuestions = async (search = "") => {
//     try {
//       let response = await getApi(
//         {
//           apiUrl: API_URLS.GET_CUSTOM_QUESTION(page,search, {
//             customSubsectionId: subSectionId,
//           }),
//         },
//         true,
//       );

//       if (response.success) {
//         let questions = response.data.map((question, index) =>
//           convertTableData(question, index + 1),
//         );
//         setTableData(questions);
//       }
//     } catch (error) {}
//   };

//   useEffect(() => {
//     getQuestions();
//   }, [page]);

//     useEffect(() => {
//       const delayDebounce = setTimeout(() => {
//          getQuestions(searchTerm); // always pass sectionId + search
//       }, 500);

//       return () => clearTimeout(delayDebounce);
//     }, [searchTerm, sectionId,getQuestions]);

//   return (
//     <div className=" md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
//         <p>Home</p>
//         <span>/</span>
//         <p>My Question Bank</p>
//         <span>/</span>
//         <p>Section</p>
//         <span>/</span>
//         <p>Sub Section</p>
//         <span>/</span>
//         <TextStyles style={{ color: "#06513D" }}> Question</TextStyles>
//       </div>

//       <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
//         <IoArrowBackCircleOutline
//           onClick={() => navigate(-1)}
//           className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition"
//         />
//         <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
//           Questions
//         </div>
//       </div>

//       <div
//         style={{
//           border: "1px solid #3BA2B959",
//           borderRadius: "10px",
//           paddingTop: "20px",
//           boxShadow: "0px 0px 16px 0px #3BA2B91F",
//           backgroundColor: "#fff",
//         }}
//         className="pt-2 px-2"
//       >
//         <div className="flex justify-between mx-8 py-4">
//           <div className=" flex items-center gap-5 ">
//             <div
//               style={{
//                 background: "#B6D4D933",
//                 height: "40px",
//               }}
//               className=" border border-[#06513D] rounded-md text-[#06513D] "
//             >
//               <p
//                 style={{
//                   fontFamily: "Calibri",
//                   fontWeight: "300",
//                   fontSize: "16px",
//                   lineHeight: "24px",
//                   letterSpacing: "0%",
//                 }}
//                 className="pt-2 px-2"
//               >
//                 TOTAL SECTION {tableData.length}
//               </p>
//             </div>
//             <SearchBar onSearch={handleSearch} width="300px" />
//           </div>
//           <Button
//             className="text-sm font-light w-40 py-5 bg-[#06513D] text-[#fff]"
//             onClick={handleOpenAddNew}
//           >
//             + Add Question
//           </Button>
//         </div>

//         {tableData.length > 0 && (
//           <>
//             <Tables
//               data={tableData}
//               headers={headers}
//               current={page}
//               total={tableData.length + (tableData.length === 10 ? 5 : 0)}
//               onChange={(page) => {
//                 setPage(page);
//               }}
//               pageSize={10}
//             />
//           </>
//         )}

//         {OpenAddNew && (
//           <AddQuestion
//             onOpen={OpenAddNew}
//             onClose={() => {
//               setOpenAddnew(false);
//             }}
//             sectionId={sectionId}
//             subSectionId={subSectionId}
//             onSuccess={handleAddQuestionSuccess}
//           />
//         )}
//         {editModalOpen && (
//           <EditQuestion
//             open={editModalOpen}
//             onClose={() => setEditModalOpen(false)}
//             sectionId={sectionId}
//             subSectionId={subSectionId}
//             onUpdate={(updatedQuestion) => {
//               setEditModalOpen(false);
//             }}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default Questions;

/*
This updated code improves the responsiveness of your Questions component.
Key enhancements:
- Uses Tailwind's responsive utilities (`sm:`, `md:`, `lg:`, etc.)
- Wraps long flex rows in `flex-wrap`
- Adds scroll or wraps text as needed
- Uses relative units where applicable
*/

// import React, { useEffect, useState } from "react";
// import { Tables } from "../../../../components/Elements/Tables/Tables";
// import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
// import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { Button } from "antd";
// import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// import { useLocation, useNavigate } from "react-router-dom";
// import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
// import AddQuestion from "./AddNew/AddQuestion";
// import { getApi } from "../../../../api/api_instance";
// import { API_URLS } from "../../../../api/apiUrls";
// import EditQuestion from "./EditQuestion";
// import { IoArrowBackCircleOutline } from "react-icons/io5";

// const Questions = () => {
//   const [OpenAddNew, setOpenAddnew] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const sectionId = location.state?.sectionId || "";
//   const subSectionId = location.state?.subSectionId || "";
//   const [tableData, setTableData] = useState([]);
//   const [page, setPage] = useState(1);
//   const [editModalOpen, setEditModalOpen] = useState(false);

//   const headers = [
//     { label: "Sr. No.", key: "serial" },
//     { label: "Questions", key: "questions" },
//     { label: "Type", key: "type" },
//     { label: "Created Date & Time", key: "createdDateAndTime" },
//     { label: "Status", key: "status" },
//     { label: "Action", key: "action" },
//   ];

//   const convertTableData = (question, serial) => ({
//     key: question._id,
//     serial,
//     questions: question.label,
//     type: question.type,
//     createdDateAndTime: "-",
//     status: "-",
//     action: (
//       <div className="flex gap-3 items-center flex-wrap">
//         <EyeIcon style={{ fontSize: "18px", cursor: "pointer" }} />
//         <EditIcon
//           style={{ cursor: "pointer" }}
//           onClick={() => setEditModalOpen(true)}
//         />
//         <CustomSwitch
//           checked={true}
//           onChange={(checked) => console.log(`Status: ${checked}`)}
//         />
//       </div>
//     ),
//   });

//   const getQuestions = async () => {
//     try {
//       let response = await getApi({
//         apiUrl: API_URLS.GET_CUSTOM_QUESTION(page, "", {
//           customSubsectionId: subSectionId,
//         }),
//       });
//       if (response.success) {
//         const questions = response.data.map((q, idx) =>
//           convertTableData(q, idx + 1),
//         );
//         setTableData(questions);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     getQuestions();
//   }, [page]);

//   return (
//     <div className=" md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
//         <p>Home</p>
//         <span>/</span>
//         <p>My Question Bank</p>
//         <span>/</span>
//         <p>Section</p>
//         <span>/</span>
//         <p>Sub Section</p>
//         <span>/</span>
//         <TextStyles style={{ color: "#06513D" }}>Question</TextStyles>
//       </div>

//       <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
//         <IoArrowBackCircleOutline
//           onClick={() => navigate(-1)}
//           className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer"
//         />
//         <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px]">
//           Questions
//         </div>
//       </div>

//       <div className="border border-[#3BA2B959] rounded-xl shadow-md bg-white p-4 sm:p-6">
//         <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
//           <div className="flex flex-wrap gap-4 items-center">
//             <div className="border border-[#06513D] rounded-md text-[#06513D] px-3 py-1 bg-[#B6D4D933] font-[Calibri] text-base">
//               TOTAL SECTION {tableData.length}
//             </div>
//             <SearchBar onSearch={() => {}} width="300px" />
//           </div>
//           <Button
//             className="text-sm font-light bg-[#06513D] text-white px-6 py-2 h-auto"
//             onClick={() => setOpenAddnew(true)}
//           >
//             + Add Question
//           </Button>
//         </div>

//         {tableData.length > 0 && (
//           <Tables
//             data={tableData}
//             headers={headers}
//             current={page}
//             total={tableData.length + (tableData.length === 10 ? 5 : 0)}
//             onChange={setPage}
//             pageSize={10}
//           />
//         )}

//         {OpenAddNew && (
//           <AddQuestion
//             onOpen={OpenAddNew}
//             onClose={() => setOpenAddnew(false)}
//             sectionId={sectionId}
//             subSectionId={subSectionId}
//             onSuccess={() => getQuestions()}
//           />
//         )}

//         {editModalOpen && (
//           <EditQuestion
//             open={editModalOpen}
//             onClose={() => setEditModalOpen(false)}
//             sectionId={sectionId}
//             subSectionId={subSectionId}
//             onUpdate={() => getQuestions()}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default Questions;

// import React, { useEffect, useState } from "react";
// import { Tables } from "../../../../components/Elements/Tables/Tables";
// import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
// import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { Button } from "antd";
// import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// import { useLocation, useNavigate } from "react-router-dom";
// import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
// import AddQuestion from "./AddNew/AddQuestion";
// import { getApi } from "../../../../api/api_instance";
// import { API_URLS } from "../../../../api/apiUrls";
// import EditQuestion from "./EditQuestion";
// import { IoArrowBackCircleOutline } from "react-icons/io5";

// const Questions = () => {
//   const [OpenAddNew, setOpenAddnew] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const sectionId = location.state?.sectionId || "";
//   const subSectionId = location.state?.subSectionId || "";
//   const [tableData, setTableData] = useState([]);
//   const [page, setPage] = useState(1);
//   const [editModalOpen, setEditModalOpen] = useState(false);

//   // Detect mobile screen width with a simple state and window resize listener
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const headers = [
//     { label: "Sr. No.", key: "serial" },
//     { label: "Questions", key: "questions" },
//     { label: "Type", key: "type" },
//     { label: "Created Date & Time", key: "createdDateAndTime" },
//     { label: "Status", key: "status" },
//     { label: "Action", key: "action" },
//   ];

//   const convertTableData = (question, serial) => ({
//     key: question._id,
//     serial: <div className="text-center">{serial}</div>,
//     questions: <div className="text-center">{question.label}</div>,
//     type: <div className="text-center">{question.type}</div>,
//     createdDateAndTime: <div className="text-center">-</div>,
//     status: <div className="text-center">-</div>,
//     action: (
//       <div className="flex justify-center items-center gap-3 flex-wrap">
//         <EyeIcon style={{ fontSize: "18px", cursor: "pointer" }} />
//         <EditIcon
//           style={{ cursor: "pointer" }}
//           onClick={() => setEditModalOpen(true)}
//         />
//         <CustomSwitch
//           checked={true}
//           onChange={(checked) => console.log(`Status: ${checked}`)}
//         />
//       </div>
//     ),
//   });

//   const getQuestions = async () => {
//     try {
//       let response = await getApi({
//         apiUrl: API_URLS.GET_CUSTOM_QUESTION(page, "", {
//           customSubsectionId: subSectionId,
//         }),
//       });
//       if (response.success) {
//         const questions = response.data.map((q, idx) =>
//           convertTableData(q, idx + 1),
//         );
//         setTableData(questions);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     getQuestions();
//   }, [page]);

//   return (
//     <div className=" md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       {/* Breadcrumbs */}
//       <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
//         <p>Home</p>
//         <span>/</span>
//         <p>My Question Bank</p>
//         <span>/</span>
//         <p>Section</p>
//         <span>/</span>
//         <p>Sub Section</p>
//         <span>/</span>
//         <TextStyles style={{ color: "#06513D" }}>Question</TextStyles>
//       </div>

//       {/* Title & Back */}
//       <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
//         <IoArrowBackCircleOutline
//           onClick={() => navigate(-1)}
//           className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer"
//         />
//         <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px]">
//           Questions
//         </div>
//       </div>

//       <div className="border border-[#3BA2B959] rounded-xl shadow-md bg-white p-4 sm:p-6">
//         <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
//           <div className="flex flex-wrap gap-4 items-center">
//             <div className="border border-[#06513D] rounded-md text-[#06513D] px-3 py-1 bg-[#B6D4D933] font-[Calibri] text-base">
//               TOTAL SECTION {tableData.length}
//             </div>
//             <SearchBar onSearch={() => {}} width="300px" />
//           </div>
//           <Button
//             className="text-sm font-light bg-[#06513D] text-white px-6 py-2 h-auto"
//             onClick={() => setOpenAddnew(true)}
//           >
//             + Add Question
//           </Button>
//         </div>

//         {/* Conditionally render table or cards based on isMobile */}
//         {!isMobile && (
//           <Tables
//             data={tableData}
//             headers={headers}
//             current={page}
//             total={tableData.length + (tableData.length === 10 ? 5 : 0)}
//             onChange={setPage}
//             pageSize={10}
//           />
//         )}

//         {isMobile && (
//           <div className="space-y-4">
//             {tableData.map((item) => (
//               <div
//                 key={item.key}
//                 className="bg-white rounded-lg shadow-md p-4 border border-gray-300"
//               >
//                 <div className="flex justify-between mb-1 font-semibold text-[#06513D]">
//                   <span>Question</span>
//                   <span>{item.questions}</span>
//                 </div>

//                 <div className="flex justify-between mb-1 text-gray-600 text-sm">
//                   <span>Type</span>
//                   <span>{item.type}</span>
//                 </div>

//                 <div className="flex justify-between mb-1 text-gray-600 text-sm">
//                   <span>Created</span>
//                   <span>{item.createdDateAndTime}</span>
//                 </div>

//                 <div className="flex justify-between mb-1 text-gray-600 text-sm">
//                   <span>Status</span>
//                   <span>{item.status}</span>
//                 </div>

//                 <div className="flex justify-between items-center">
//                   <div className="flex gap-4">
//                     <EyeIcon
//                       className="cursor-pointer"
//                       onClick={() => {
//                         // your action here
//                       }}
//                     />
//                     <EditIcon
//                       className="cursor-pointer"
//                       onClick={() => setEditModalOpen(true)}
//                     />
//                     <CustomSwitch checked={true} onChange={() => {}} />
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {OpenAddNew && (
//           <AddQuestion
//             onOpen={OpenAddNew}
//             onClose={() => setOpenAddnew(false)}
//             sectionId={sectionId}
//             subSectionId={subSectionId}
//             onSuccess={() => getQuestions()}
//           />
//         )}

//         {editModalOpen && (
//           <EditQuestion
//             open={editModalOpen}
//             onClose={() => setEditModalOpen(false)}
//             sectionId={sectionId}
//             subSectionId={subSectionId}
//             onUpdate={() => getQuestions()}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default Questions;

import React, { useEffect, useState } from "react";
import { Tables } from "../../../../components/Elements/Tables/Tables";
import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import { Button } from "antd";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import { useLocation, useNavigate } from "react-router-dom";
import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
import AddQuestion from "./AddNew/AddQuestion";
import { getApi } from "../../../../api/api_instance";
import { API_URLS } from "../../../../api/apiUrls";
import EditQuestion from "./EditQuestion";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { GoCopilot } from "react-icons/go";

const Questions = () => {
  const [OpenAddNew, setOpenAddnew] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const sectionId = location.state?.sectionId || "";
  const subSectionId = location.state?.subSectionId || "";
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(1);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Add search state
  const [loading, setLoading] = useState(false); // Add loading state

  // Detect mobile screen width with a simple state and window resize listener
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Questions", key: "questions" },
    { label: "Type", key: "type" },
    { label: "Created Date & Time", key: "createdDateAndTime" },
    { label: "Status", key: "status" },
    { label: "Action", key: "action" },
  ];

  const convertTableData = (question, serial) => ({
    key: question._id,
    serial: (
      <div className="text-center" title="">
        {serial}
      </div>
    ),
    questions: (
      <div className="text-center" title="">
        {question.label}
      </div>
    ),
    type: (
      <div className="text-center" title="">
        {question.type}
      </div>
    ),
    createdDateAndTime: (
      <div className="text-center" title="">
        -
      </div>
    ),
    status: (
      <div className="text-center" title="">
        -
      </div>
    ),
    action: (
      <div
        className="flex justify-center items-center gap-3 flex-wrap"
        title=""
      >
        <EyeIcon style={{ fontSize: "18px", cursor: "pointer" }} />
        <EditIcon
          style={{ cursor: "pointer" }}
          onClick={() => setEditModalOpen(true)}
        />
        <CustomSwitch
          checked={true}
          onChange={(checked) => console.log(`Status: ${checked}`)}
        />
      </div>
    ),
  });

  const getQuestions = async () => {
    try {
      setLoading(true);
      let response = await getApi({
        apiUrl: API_URLS.GET_CUSTOM_QUESTION(
          page,
          {
            customSubsectionId: subSectionId,
          },
          searchTerm, // Pass the search term as the third parameter
        ),
      });
      if (response.success) {
        const questions = response.data.map((q, idx) =>
          convertTableData(q, idx + 1),
        );
        setTableData(questions);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Handle search functionality

  const handleSearch = (value) => {
    setSearchTerm(value);
    setPage(1); // Reset to first page when searching
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchTerm("");
    setPage(1);
  };

  useEffect(() => {
    getQuestions();
  }, [searchTerm]); // Remove page dependency since we're not using pagination in API

  return (
    <div className=" md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {/* Breadcrumbs */}
      <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
        <p>Home</p>
        <span>/</span>
        <p>My Question Bank</p>
        <span>/</span>
        <p>Section</p>
        <span>/</span>
        <p>Sub Section</p>
        <span>/</span>
        <TextStyles style={{ color: "#06513D" }}>Question</TextStyles>
      </div>

      {/* Title & Back */}
      <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
        <IoArrowBackCircleOutline
          onClick={() => navigate(-1)}
          className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer"
        />
        <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px]">
          Questions
        </div>
      </div>

      <div className="border border-[#3BA2B959] rounded-xl shadow-md bg-white p-4 sm:p-6">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          <div className="flex flex-wrap gap-4 items-center">
            <div className="border border-[#06513D] rounded-md text-[#06513D] px-3 py-1 bg-[#B6D4D933] font-[Calibri] text-base">
              TOTAL SECTION {tableData.length}
            </div>
            <SearchBar
              onSearch={handleSearch}
              onClear={handleClearSearch}
              width="300px"
              placeholder="Search questions..."
              value={searchTerm}
            />
          </div>
          <Button
            className="text-sm font-light bg-[#06513D] text-white px-6 py-2 h-auto"
            onClick={() => setOpenAddnew(true)}
          >
            + Add Question
          </Button>
        </div>

        {/* Show loading indicator if needed */}
        {loading && (
          <div className="text-center py-4">
            <span>Loading...</span>
          </div>
        )}

        {/* Show no results message when search returns empty */}
        {!loading && searchTerm && tableData.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            <p>No questions found for "{searchTerm}"</p>
            <button
              onClick={handleClearSearch}
              className="text-[#06513D] underline mt-2"
            >
              Clear search
            </button>
          </div>
        )}

        {/* Conditionally render table or cards based on isMobile */}
        {!isMobile && !loading && (
          <Tables
            data={tableData}
            headers={headers}
            current={page}
            total={tableData.length + (tableData.length === 10 ? 5 : 0)}
            onChange={setPage}
            pageSize={10}
          />
        )}

        {isMobile && !loading && (
          <div className="space-y-4">
            {tableData.map((item) => (
              <div
                key={item.key}
                className="bg-white rounded-lg shadow-md p-4 border border-gray-300"
              >
                <div className="flex justify-between mb-1 font-semibold text-[#06513D]">
                  <span>Question</span>
                  <span>{item.questions}</span>
                </div>

                <div className="flex justify-between mb-1 text-gray-600 text-sm">
                  <span>Type</span>
                  <span>{item.type}</span>
                </div>

                <div className="flex justify-between mb-1 text-gray-600 text-sm">
                  <span>Created</span>
                  <span>{item.createdDateAndTime}</span>
                </div>

                <div className="flex justify-between mb-1 text-gray-600 text-sm">
                  <span>Status</span>
                  <span>{item.status}</span>
                </div>

                <div className="flex justify-between items-center">
                  <div className="flex gap-4">
                    <EyeIcon
                      className="cursor-pointer"
                      onClick={() => {
                        // your action here
                      }}
                    />
                    <EditIcon
                      className="cursor-pointer"
                      onClick={() => setEditModalOpen(true)}
                    />
                    <CustomSwitch checked={true} onChange={() => {}} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {OpenAddNew && (
          <AddQuestion
            onOpen={OpenAddNew}
            onClose={() => setOpenAddnew(false)}
            sectionId={sectionId}
            subSectionId={subSectionId}
            onSuccess={() => getQuestions()}
          />
        )}

        {editModalOpen && (
          <EditQuestion
            open={editModalOpen}
            onClose={() => setEditModalOpen(false)}
            sectionId={sectionId}
            subSectionId={subSectionId}
            onUpdate={() => getQuestions()}
          />
        )}
      </div>
    </div>
  );
};

export default Questions;
